// extracted by mini-css-extract-plugin
module.exports = {"list":"menu-link_list__BMRD7","list__item":"menu-link_list__item__1iYPO","list__itemLink":"menu-link_list__itemLink__1RgOG"};